import { render, staticRenderFns } from "./EvaluateModel.vue?vue&type=template&id=526737b0&scoped=true"
import script from "./EvaluateModel.vue?vue&type=script&lang=js"
export * from "./EvaluateModel.vue?vue&type=script&lang=js"
import style0 from "./EvaluateModel.vue?vue&type=style&index=0&id=526737b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526737b0",
  null
  
)

export default component.exports